export default "__VITE_ASSET__SUFYMgt___"